<template>
  <div>
    <el-form :inline="true" :model="filters" :size="size">
      <el-form-item class="select_btn_140">
        <el-select
          class="select_btn_style"
          v-model="filters.displayClientTypes"
          placeholder="展示终端"
          multiple
          collapse-tags
        >
          <el-option
            v-for="(item, i) in clientTypeData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn_140">
        <el-select
          class="select_btn_style"
          v-model="filters.tagKeys"
          placeholder="视频标签"
          multiple
          collapse-tags
        >
          <el-option
            v-for="(item, i) in videoTagData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-cascader
          class="select_btn_style"
          v-model="filters.categoryId"
          placeholder="视频集分类"
          :options="videoCategoryData"
          :props="{
            label: 'name',
            value: 'id',
            children: 'children',
            checkStrictly: true,
          }"
          clearable
        >
        </el-cascader>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.onlineStatus"
          placeholder="上线状态"
        >
          <el-option
            v-for="(item, i) in onlineStatusData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.sharedStatus"
          placeholder="共享状态"
        >
          <el-option
            v-for="(item, i) in sharedData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="m-l-14">
        <el-input
          prefix-icon="el-icon-search"
          v-model="filters.videoSetName"
          placeholder="请输入视频集/视频名称"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-form :inline="true" :model="filters" :size="size">
      <el-form-item label="上线时间：">
        <el-date-picker
          v-model="filters.onlineTimeRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <butn btntype="primary" title="查询" @click.native="initData"></butn>
        <butn
          :title="'重置'"
          @click.native="resetData"
          class="czButn"
        ></butn> </el-form-item
    ></el-form>
  </div>
</template>
<script>
import { resCategoryTree } from "@/api/rescategory";
import { getSysParamByTypes } from "@/api/sysParam";
import butn from "@/components/button/index";
export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      size: "small",
      filters: {},
      onlineStatusData: [],
      sharedData: [],
      videoCategoryData: [],
      clientTypeData: [],
      videoTagData: [],
      showName: "",
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },
  created() {
    // 获取视频分类数据
    resCategoryTree({ categoryType: 0, display: 1 }).then((res) => {
      if (!res || res.code != 0) return;
      this.videoCategoryData = res.data;
    });
    this.getSysParamByTypes([
      "ONLINE_STATUS",
      "SHARED_SCREEN_STATUS",
      "DISPLAY_CLIENT_TYPE",
      "RECOMMEND_TAG",
    ]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["ONLINE_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["SHARED_SCREEN_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.onlineStatusData = res.data["ONLINE_STATUS"];
        this.sharedData = res.data["SHARED_SCREEN_STATUS"];
        this.clientTypeData = res.data["DISPLAY_CLIENT_TYPE"] || [];
        this.videoTagData = res.data["RECOMMEND_TAG"] || [];
      });
    },
    initData() {
      let params = { ...this.filters };
      if (
        Array.isArray(params.onlineTimeRange) &&
        params.onlineTimeRange.length > 1
      ) {
        params.startTime = params.onlineTimeRange[0];
        params.endTime = params.onlineTimeRange[1];
        delete params.onlineTimeRange;
      }
      //查询
      this.$emit("search", {
        ...params,
        t: new Date().getTime(),
        categoryId: this.filters.categoryId
          ? JSON.parse(JSON.stringify(this.filters.categoryId)).pop()
          : "",
      });
    },
    resetData() {
      //重置
      this.showName = "";
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>

<style lang="scss" scoped>
.tree-content {
  max-height: 400px;
  overflow: auto;
}
.sel-button {
  cursor: pointer;
  width: 118px;
  height: 30px;
  text-align: center;
  background: #edf2f9;
  border-radius: 2px;
  border: 1px solid #d7dbe0;
}
</style>